<template>
  <div class="paychological-page">
     <!-- 1. Banner 区域 (深色) -->
   <section class="lib-banner">
  <div class="banner-overlay"></div>
  <div class="container">
    <div class="banner-content">
      <h1>德育评价系统</h1>
      <p class="subtitle">以数据驱动德育，用评价赋能成长</p>
      <p class="description">构建全过程、多维度、可视化的德育评价体系，帮助学校科学评价学生品德发展，助力家校共育，促进学生全面成长。</p>
      <button class="btn-primary" @click="contactUs">
        合作咨询 <span class="divider">|</span> 020-82038386
      </button>
    </div>
  </div>
</section>
    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回产品矩阵</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'AILipaychological',
  components: {  AppFooter },
  data() {
    return {
     
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    }
  }
}
</script>

<style scoped>
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* 1. Banner (深色背景图) */
.lib-banner {
  position: relative;
  /* 左侧深色背景，与图片左侧黑色融合 */
  background-color: #0a0a0a;
  background-image: url('../assets/images/MoraleducationEvaluation-bg.png');
  /* 高度填满容器，宽度自动按比例缩放 */
  background-size: auto 100%;
  /* 靠右对齐，人物和数据卡片完整显示 */
  background-position: right center;
  background-repeat: no-repeat;
  color: #fff;
  padding: 0;
  height: 580px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* 渐变遮罩：左侧深色保护文字，右侧透明显示人物和卡片 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right, 
    #0a0a0a 0%, 
    #0a0a0a 25%,
    rgba(10, 10, 10, 0.85) 40%,
    rgba(10, 10, 10, 0.4) 55%,
    transparent 70%
  );
  z-index: 1;
}

.lib-banner .container { 
  display: flex; 
  align-items: center; 
  justify-content: flex-start;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 5%;
  position: relative;
  z-index: 2;
}

.banner-content { 
  max-width: 550px;
}

.banner-content h1 { 
  font-size: 52px; 
  line-height: 1.2; 
  margin-bottom: 20px; 
  font-weight: bold;
  color: #fff;
}

.subtitle { 
  font-size: 22px; 
  color: rgba(255, 255, 255, 0.95); 
  margin-bottom: 20px; 
  font-weight: 500;
}

.description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  margin-bottom: 36px;
  max-width: 480px;
}

.btn-primary { 
  background: #10b1f2; 
  color: #fff; 
  border: none; 
  padding: 14px 32px;
  border-radius: 24px; 
  font-size: 16px; 
  cursor: pointer; 
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.btn-primary:hover { 
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
}

.divider {
  opacity: 0.6;
  margin: 0 4px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .lib-banner {
    height: 500px;
  }
  .banner-content h1 { font-size: 44px; }
}

@media (max-width: 992px) {
  .lib-banner {
    height: 450px;
  }
  .banner-content h1 { font-size: 36px; }
  .subtitle { font-size: 18px; }
  .description { font-size: 14px; }
  .banner-overlay {
    background: rgba(10, 10, 10, 0.9);
  }
}

@media (max-width: 768px) {
  .lib-banner {
    height: 400px;
  }
  .banner-content h1 { font-size: 28px; }
  .subtitle { font-size: 16px; }
  .description { font-size: 13px; }
}

/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style>